<template>
  <section v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">指派员工提交参数</button>
  </section>
</template>

<script>
import { doQueryByOrgId } from 'api/operate';
export default {
  props: {
    modeOtherData: {
      type: Object,
      default: () => ({}),
    },
    showComponent: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      otherFormData: {
        lineInfo: {},
        // 跟单人员信息
        localUserInfo: {},
      },
      baseForm: {
        form: [
          {
            label: '跟单人员',
            value: 'localUserName',
            type: 'el-autocomplete',
            valueKey: 'linkman',
            placeholder: '请输入跟单人员姓名',
            hide: false,
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let resInfo = [];
              if (queryString && queryString.length) {
                // 如果修改了但是没选中新的，就清空相关的字段
                if (this.otherFormData.localUserInfo.linkman !== queryString) {
                  this.$refs.baseForm.setVal('localPhone', '');
                  this.$refs.baseForm.setVal('localUser', '');
                }
                doQueryByOrgId({ linkman: queryString }).then((res) => {
                  if (res && res.items) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
              cb(resInfo);
            },
            onSelect: (item) => {
              if (item.userId) {
                this.otherFormData.localUserInfo = item;
                this.setBaseForm(this.otherFormData.localUserInfo);
              }
            },
          },
          {
            label: '跟单手机',
            value: 'localPhone',
            type: 'input',
            readonly: true,
            placeholder: '跟单人员手机',
          },
          {
            label: '跟单人员Id',
            value: 'localUser',
            type: 'input',
            readonly: true,
            hide: true,
          },
          {
            label: '拦标价',
            value: 'guidePrice',
            type: 'input',
            hide: false,
          },
          {
            label: '承包价',
            value: 'totalFee',
            type: 'input',
            hide: false,
          },
        ],
        rules: {
          localUserName: [
            { required: true, message: '请选择跟单人员', trigger: 'blur' },
          ],
          guidePrice: [
            { required: true, message: '请输入拦标价', trigger: 'blur' },
          ],
          totalFee: [
            { required: true, message: '请输入承包价', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      // console.log('指派员工提交参数', this.sub());
    },
    setData (data) {
      if (data) {
        this.otherFormData.lineInfo = data.lineInfo;
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !(!data.lineInfo.lineId || data.lineInfo.lineId <= 0),
          names: ['guidePrice', 'totalFee'],
        });
      }
    },
    // 恢复成原始模样
    initForm () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['guidePrice', 'totalFee'],
      });
      this.otherFormData.lineInfo = {};
      this.$refs.baseForm.setVal('localUserName', '');
      this.$refs.baseForm.setVal('localPhone', '');
      this.$refs.baseForm.setVal('localUser', '');
      this.$refs.baseForm.setVal('guidePrice', 0);
      this.$refs.baseForm.setVal('totalFee', 0);
    },
    setBaseForm (data) {
      this.setVehicleStaffForm(data);
      this.$emit('setBelongForm', data);
    },
    setVehicleStaffForm (data) {
      this.$refs.baseForm.setVal('localUserName', data.linkman || '');
      this.$refs.baseForm.setVal('localPhone', data.loginAcct || '');
      this.$refs.baseForm.setVal('localUser', data.userId || '');
    },
    setCacheAndDetailData (data) {
      this.initForm();
      this.otherFormData.localUserInfo = {
        linkman: data.localUserName,
        loginAcct: data.localPhone,
        userId: data.localUser,
      };
      this.$refs.baseForm.setVal('localUserName', data.localUserName || '');
      this.$refs.baseForm.setVal('localPhone', data.localPhone || '');
      this.$refs.baseForm.setVal('localUser', data.localUser || '');
      this.$refs.baseForm.setVal('guidePrice', data.guidePrice || 0);
      this.$refs.baseForm.setVal('totalFee', data.totalFee || 0);
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
  },
  watch: {
    showComponent: {
      immediate: true,
      handler (newValue, oldValue) {
        this.setFormRuleAttr({
          rules: this.baseForm.rules,
          attr: 'required',
          value: newValue,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
